<template>
    <div>
        <div id="modal" class="modal is-active">
            <div class="modal-background"></div>
            <div class="modal-content">
                <div class="box">
                    <article class="media">
                        <div class="media-left">
                            <figure class="image is-64x64">
                                <img  :src="provider.logo"  alt="Image">
                            </figure>
                        </div>
                        <div class="media-content">
                            <div class="content">
                                <div>
                                    <h3 class="headline mb-0">{{ provider.name }}</h3>
                                    <div>Origen {{ provider.phone }}</div>
                                    <div v-if="phone">Destino: {{ phone }}</div>
                                </div>
                            </div>
                            <form v-if="onCall" @submit.prevent="handleHide">
                                <div>
                                    <div class="columns">
                                        <div class="column is-1">
                                            <a class="button is-fullwidth" @click="handleSendDigits(1)">1</a>
                                        </div>
                                        <div class="column is-1">
                                            <a class="button is-fullwidth" @click="handleSendDigits(2)">2</a>
                                        </div>
                                        <div class="column is-1">
                                            <a class="button is-fullwidth" @click="handleSendDigits(3)">3</a>
                                        </div>
                                    </div>
                                    <div class="columns">
                                        <div class="column is-1">
                                            <a class="button is-fullwidth" @click="handleSendDigits(4)">4</a>
                                        </div>
                                        <div class="column is-1">
                                            <a class="button is-fullwidth" @click="handleSendDigits(5)">5</a>
                                        </div>
                                        <div class="column is-1">
                                            <a class="button is-fullwidth" @click="handleSendDigits(6)">6</a>
                                        </div>
                                    </div>
                                    <div class="columns">
                                        <div class="column is-1">
                                            <a class="button is-fullwidth" @click="handleSendDigits(7)">7</a>
                                        </div>
                                        <div class="column is-1">
                                            <a class="button is-fullwidth" @click="handleSendDigits(8)">8</a>
                                        </div>
                                        <div class="column is-1">
                                            <a class="button is-fullwidth" @click="handleSendDigits(9)">9</a>
                                        </div>
                                    </div>
                                    <div class="columns">
                                        <div class="column is-1">
                                            <a class="button is-fullwidth" @click="handleSendDigits('*')">*</a>
                                        </div>
                                        <div class="column is-1">
                                            <a class="button is-fullwidth" @click="handleSendDigits(0)">0</a>
                                        </div>
                                        <div class="column is-1">
                                            <a class="button is-fullwidth" @click="handleSendDigits('#')">#</a>
                                        </div>
                                    </div>
                                    <br>
                                </div>
                                <div class="columns">
                                    <div class="column">
                                        <button type="submit" class="button is-success is-fullwidth">Terminar Llamada</button>
                                    </div>
                                </div>

                            </form>

                            <div class="notification is-danger" v-if="error">
                                <button class="delete" @click="handleCloseError"></button>
                                {{error}}
                            </div>

                            <form @submit.prevent="createCall" v-if="! onCall && !loading">

                            <b-radio v-model="typeCall"
                                     native-value="external">
                                Externa
                            </b-radio>
                            <b-radio v-model="typeCall"
                                     native-value="internal">
                                Interna
                            </b-radio>

                            </form>
                            <br>

                            <form @submit.prevent="createCallExtension" v-if="! onCall && typeCall === 'internal'">
                                <div class="columns">
                                    <div class="column is-0">
                                        <b-select class="is-fullwidth" placeholder="Seleccionar operador" icon="account" required v-model="to_worker">
                                            <optgroup
                                                v-for="provider in workers"
                                                :key="provider.id"
                                                :label="provider.name">
                                                <option
                                                    v-for="option in provider.workspace.workers"
                                                    v-if="showWorker(option)"
                                                    :value="option.id"
                                                    :key="option.id">
                                                    {{ option.user.profile.fullName }} - {{option.activity?option.activity.name:'Offline'}}
                                                </option>
                                            </optgroup>

                                        </b-select>
                                    </div>
                                </div>
                                <div class="columns">
                                    <div class="column is-6">
                                        <button class="button is-primary is-fullwidth" type="submit">Realizar llamada</button>
                                    </div>
                                    <div class="column is-6">
                                        <a class="button is-secondary is-fullwidth" @click.once="handleHide" >Cancelar</a>
                                    </div>
                                </div>

                            </form>

                            <form @submit.prevent="createCall" v-if="! onCall && typeCall === 'external'">
                                <vue-tel-input v-model="phone"
                                               @onInput="onInput"
                                               defaultCountry="MX"
                                               placeholder="Ingrese número telefónico"
                                               :onlyCountries="countries"
                                               :required="required"
                                               :disabledFetchingCountry="disabledFetchingCountry"
                                >
                                </vue-tel-input>
                                <p>* Para marcar celular sustituir el 044 por 1</p>
                                <br>
                                <div class="columns">
                                    <div class="column is-6">
                                        <button class="button is-primary is-fullwidth" type="submit">Realizar llamada</button>
                                    </div>
                                    <div class="column is-6">
                                        <a class="button is-secondary is-fullwidth" @click.once="handleHide" >Cancelar</a>
                                    </div>
                                </div>
                            </form>
                            <p v-if="loading">Conectando llamada espere...</p>
                        </div>
                    </article>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    // import Timer from 'easytimer'
    export default {
        name: "OutcomingModal",
        props: {
            workers: Array
        },
        data() {
            return {
                provider: this.$auth.user().provider,
                onCall: false,
                typeCall: 'external',
                phone: '',
                validPhone: true,
                countries: ['MX'],
                required: true,
                disabledFetchingCountry: true,
                to_worker: null,
                loading: false,
                error: '',
            }
        },
        mounted() {
            this.prepareComponent();
        },
        methods: {
            prepareComponent(){

            },
            handleHide(){
                if(this.onCall){
                    this.$emit('hangup');
                }
                this.$http.post('/ivr/worker_update');
                this.$store.commit('showOutcoming', false);
            },
            onInput({ number, isValid, country }) {
                // console.log(number, isValid, country);
            },
            createCall(){
                console.log('p phone', this.$auth.user().provider.phone);
                this.$emit('outcoming-call', {
                    To:this.phone,
                    From: this.$auth.user().provider.phone
                });
                this.error = null;
                this.onCall=true;
            },
            createCallExtension(){
                this.$emit('outcoming-call', {To:'Worker'+this.to_worker});
                this.onCall=true;
            },
            showWorker(worker){
                return worker.user.id !== this.$auth.user().id;
            },
            handleCloseError(){
                this.error = null;
            },
            handleSendDigits(digit){
                digit = '' + digit;
                // console.log(digit)
               this.$emit('send-digits', {digits:digit});
            }
        }
    }
</script>

<style scoped>
    .modal .modal-content{
        width: 50%;
    }
</style>
